const Platforms = [
    {
      "id": "Facebook",
      "width": 1230,
      "height": 600,
      "textWidth": 1100
    },

    {
      "id": "Twitter",
      "width": 1200,
      "height": 600,
      "textWidth": 1100
    },

    {
      "id": "Instagram",
      "width": 1200,
      "height": 1200,
      "textWidth": 1100
    },

    {
      "id": "Snap",
      "width": 900, 
      "height": 1600,
      "textWidth": 800
    }
]

export default Platforms


// WEBPACK FOOTER //
// ./src/data/Platforms.js